import * as React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Modal from "react-modal";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Typewriter from "typewriter-effect";

// Redux
import { requestTrialAccount } from "../../../redux/action/landingPageAction";
import { fetchMasterData } from "../../../redux/action/masterDataAction";

// MUI Library
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

// RSuite Library
import { SelectPicker } from "rsuite";

// User-defined Components
import Buttonaction from "../../../components/Buttonaction";
import SuccessModal from "../../../components/Successmodal";

// Assets
import AuctionBannerWhite from "../../../assets/images/AuctionBannerWhite.svg";
import Header from "../../../assets/images/landingpage/header.svg";
import Document from "../../../assets/images/landingpage/icon/document.svg";
import Location from "../../../assets/images/landingpage/icon/location.svg";
import Phone from "../../../assets/images/landingpage/icon/phone.svg";
import RealTime from "../../../assets/images/landingpage/icon/real-time.svg";
import ShoppingCart from "../../../assets/images/landingpage/icon/shopping-cart.svg";
import Telescope from "../../../assets/images/landingpage/icon/telescope.svg";
import WhiteWave from "../../../assets/images/landingpage/white-wave.svg";

const LandingPage = ({ dataMasters }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [formInput, setFormInput] = React.useState({
    name: "",
    email: "",
    phonePrefix: "",
    phone: "",
    companyName: "",
  });

  React.useEffect(() => {
    if (!dataMasters) dispatch(fetchMasterData());
  }, [formInput]);

  const modalFreeTrial = React.useRef();

  const [show, setShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const submitFreeTrial = () => {
    setLoading(true);
    new Promise((resolve, reject) => {
      dispatch(
        requestTrialAccount(
          formInput,
          (res) => {
            resolve();
          },
          () => {
            reject();
          }
        )
      );
    })
      .then(() => {
        setShow(false);
        modalFreeTrial.current.show({
          title: "Permintaan berhasil dikirim",
          description: "Kami akan segera menghubungi Anda",
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setFormInput({
          name: "",
          email: "",
          phonePrefix: "",
          phone: "",
          companyName: "",
        });
      });
  };

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const pages = [
    { menu: "Beranda", href: "#home" },
    { menu: "Keunggulan", href: "#benefit" }
  ];

  const firstBenefit = [
    {
      image: Telescope,
      title: "Online Auction",
      subTitle:
        "Keamanan proses lelang yang terjaga sehingga tetap kredibel dan transparan",
    },
    {
      image: ShoppingCart,
      title: "Negotiation",
      subTitle:
        "Dapatkan penawaran kompetitif dari setiap vendor dan lakukan negosiasi untuk mendapatkan harga termurah",
    },
    {
      image: RealTime,
      title: "Realtime",
      subTitle:
        "Pantau proses lelang secara aktual untuk menjaga anda dari penipuan yang terjadi selama proses lelang",
    },
    {
      image: Document,
      title: "Reporting",
      subTitle:
        "Lihat dan cetak laporan riwayat proses lelang kapanpun dan dimanapun anda butuhkan",
    },
  ];

  const secondBenefit = [
    {
      text: "Monitoring secara aktual, komprehensive dan aman untuk menjaga keadilan selama proses lelang berlangsung",
    },
    { text: "Tampilan yang lebih mudah digunakan" },
    {
      text: "Beragam metode auction yang sesuai dengan kebutuhan organisasi anda seperti metode least cost system, passing grade atau merit point.",
    },
    {
      text: "Membantu anda mendapatkan penawaran terendah sehingga mencapai target best saving yang maksimal",
    },
    { text: "Lihat dan cetak riwayat auction kapanpun anda butuhkan" },
  ];

  const [faq, setFaq] = React.useState([
    {
      question: "Apa itu Ruang Auction?",
      answer:
        "Ruang Auction adalah aplikasi berbasis cloud untuk melakukan reverse auction pada proses pengadaan barang dan/atau jasa.",
      show: false,
    },
    {
      question: "Siapa yang dapat menggunakan Ruang Auction?",
      answer:
        "Seluruh perusahaan yang melakukan pengadaan pada semua kategori usaha.",
      show: false,
    },
    {
      question: "Bagaiamana pricing pada Ruang Auction?",
      answer:
        "Ruang Auction membebankan user-per-month dalam melakukan penagihan penggunaannya.",
      show: false,
    },
    {
      question: "Apakah saya dapat mengajukan demo?",
      answer: "Ya, silakan kontak sales dan marketing kami.",
      show: false,
    },
    {
      question:
        "Browser apa yang dapat digunakan untuk mengakses Ruang Auction?",
      answer:
        "Disarankan menggunakan browser Google Chrome atau Mozila Firefox dengan versi terbaru.",
      show: false,
    },
  ]);

  return (
    <>
      <AppBar
        id="beranda"
        position="static"
        style={{ backgroundColor: "#00446B", position: "fixed", zIndex: "100" }}
      >
        <Container
          maxWidth="l"
          style={{ boxShadow: "0px 0px 30px 0px #0000001A", zIndex: "99" }}
        >
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <img
                src={AuctionBannerWhite}
                alt="Ruang Auction Logo"
                style={{
                  height: "35px",
                  position: "relative",
                }}
              />
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page, index) => (
                  <MenuItem
                    key={index}
                    onClick={handleCloseNavMenu}
                    href={page.href}
                  >
                    <Typography textAlign="center">{page.menu}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              <img src={AuctionBannerWhite} width="100" />
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {pages.map((page, index) => (
                <HoverAppBar
                  href={page.href}
                  key={index}
                  onClick={handleCloseNavMenu}
                  sx={{
                    width: "fit-content",
                    my: 2,
                    color: "white",
                    display: "block",
                    marginRight: "40px",
                    textAlign: "center",
                    height: "100%",
                    marginLeft: index === 0 && "50px",
                  }}
                >
                  {page.menu}
                </HoverAppBar>
              ))}
            </Box>

            <div
              className="mr-5"
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#FFFFFF",
                cursor: "pointer",
              }}
              onClick={() => history.push("/buyer-login")}
            >
              Login
            </div>

          </Toolbar>
        </Container>
      </AppBar>
      <div
        id="home"
        className="position-relative"
        style={{
          backgroundColor: "#00446B",
          height: "788px",
          paddingTop: "80px",
        }}
      >
        <Row className="mx-0 h-100 px-4">
          <Col className="d-flex align-items-center">
            <div>
              <div>
                <p
                  style={{
                    color: "white",
                    fontWeight: "700",
                    fontSize: "40px",
                  }}
                >
                  Lakukan Proses Lelang Dengan
                </p>
              </div>
              <div
                style={{
                  fontSize: "40px",
                  fontWeight: "700",
                  color: "white",
                }}
              >
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .typeString("Efisien")
                      .pauseFor(2500)
                      .deleteAll()
                      .typeString("Aktual")
                      .pauseFor(2500)
                      .deleteAll()
                      .typeString("Transparan")
                      .pauseFor(2500)
                      .deleteAll()
                      .typeString("Mudah")
                      .pauseFor(2500)
                      .start();
                  }}
                  options={{
                    loop: true,
                  }}
                />
              </div>
              <div
                className="my-4"
                style={{
                  fontSize: "14px",
                  fontWeight: "normal",
                  color: "#FFFFFF",
                }}
              >
                Dapatkan pengalaman lelang terbaik Anda dan raih best saving
                secara maksimal
              </div>
              <div>
                
              </div>
            </div>
          </Col>
          <Col className="d-flex align-items-center justify-content-center">
            <img
              src={Header}
              alt="Header Image"
              style={{ position: "relative", inset: "-50px -25px" }}
              width="95%"
            />
          </Col>
        </Row>
        <img
          src={WhiteWave}
          className="position-absolute"
          style={{ width: "99.6vw", left: "0", bottom: "0" }}
        />
      </div>
      
      <div
        className="py-5"
        style={{
          backgroundColor: "#00446B",
          paddingLeft: "120px",
          paddingRight: "120px",
        }}
      >
        <img src={AuctionBannerWhite} alt="Ruang Auction Logo" height="50" />
        <p
          className="mt-3"
          style={{ fontSize: "12px", fontWeight: "400", color: "white" }}
        >
          The Gade Tower, Jl. Kramat Raya No.162, Kenari, Kec. Senen
        </p>
        <p
          style={{
            fontSize: "12px",
            fontWeight: "400",
            color: "white",
            marginTop: "0px",
          }}
        >
          Kota Jakarta Pusat, Jakarta 10430, Indonesia
        </p>
        
        <Row className="mx-0">
          <Col
            lg={4}
            style={{ margin: "15px 0 0 0", paddingLeft: "8px" }}
            className="   px-0"
          >
            
            <div className="mb-3 d-flex">
              <img src={Phone} alt="Phone Asset" />
              <HoverUnderline>
                <a
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "white",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                >
                  021-3155550 & 021-80635162
                </a>
              </HoverUnderline>
            </div>
            <div className="d-flex">
              <img src={Location} alt="Location Asset" />
              <HoverUnderline>
                <a
                  href="https://maps.app.goo.gl/aBAG3xVe3p5ZShH58"
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "white",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                >
                  PT Pegadaian
                </a>
              </HoverUnderline>
            </div>
          </Col>
          
        </Row>
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          backgroundColor: "#0772B6",
          height: "50px",
          textAlign: "center",
          fontWeight: "400",
          fontSize: "14px",
          color: "white",
        }}
      >
        Copyright 2024 &#169; Ruang Auction Powered by Promise
      </div>
      <Modal
        isOpen={show}
        style={{
          overlay: {
            zIndex: "1060",
            background: "rgba(0,0,0,.7)",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "12px",
            transition: "all .3s ease",
            backgroundColor: "white",
            overflow: "auto",
            maxHeight: "80vh",
            zIndex: "1060",
            padding: "32px",
          },
        }}
      >
        <p
          style={{
            fontSize: "18px",
            fontWeight: "500",
            color: "#454545",
            textAlign: "center",
          }}
        >
          Dapatkan Uji Coba Aplikasi Ruang Auction Gratis
        </p>
        <p
          style={{
            fontWeight: "400",
            fontSize: "12px",
            color: "#909090",
            textAlign: "center",
          }}
        >
          Kami akan menghubungi anda dengan segera untuk memberikan uji coba
          aplikasi
        </p>
        <hr style={{ borderColor: "#C4C4C4" }} />

        <Form.Group>
          <Form.Label
            style={{ fontSize: "12px", fontWeight: "400", color: "#454545" }}
          >
            Nama Anda
          </Form.Label>
          <Form.Control
            value={formInput.name}
            type="text"
            size="lg"
            style={{ height: "98%" }}
            onChange={(v) =>
              setFormInput({ ...formInput, name: v.target.value })
            }
          />
        </Form.Group>
        <Form.Group>
          <Form.Label
            style={{ fontSize: "12px", fontWeight: "400", color: "#454545" }}
          >
            Email Perusahaan
          </Form.Label>
          <Form.Control
            value={formInput.email}
            type="email"
            size="lg"
            style={{ height: "98%" }}
            onChange={(v) =>
              setFormInput({ ...formInput, email: v.target.value })
            }
          />
        </Form.Group>
        <Form.Group>
          <Form.Label
            style={{ fontSize: "12px", fontWeight: "400", color: "#454545" }}
          >
            Nomor Handphone
          </Form.Label>
          <Row className="mx-0">
            <Col lg={3} className="mx-0 px-0">
              <SelectPicker
                size="lg"
                value={formInput.phonePrefix}
                data={dataMasters?.phonePrefix}
                searchable={false}
                className="selectpicker"
                onChange={(v) => {
                  setFormInput({
                    ...formInput,
                    phonePrefix: v,
                  });
                }}
              />
            </Col>
            <Col className="px-0 ml-2">
              <Form.Control
                value={formInput.phone}
                type="number"
                size="lg"
                style={{ height: "98%" }}
                placeholder="Phone number without 0"
                onChange={(v) =>
                  setFormInput({ ...formInput, phone: v.target.value })
                }
              />
            </Col>
          </Row>
        </Form.Group>
        <Form.Group>
          <Form.Label
            style={{ fontSize: "12px", fontWeight: "400", color: "#454545" }}
          >
            Nama Perusahaan
          </Form.Label>
          <Form.Control
            value={formInput.companyName}
            type="text"
            size="lg"
            style={{ height: "98%" }}
            onChange={(v) =>
              setFormInput({ ...formInput, companyName: v.target.value })
            }
          />
        </Form.Group>
        <Row className="mt-4" style={{ width: "100%" }}>
          <Col className="d-flex justify-content-end" lg={6}>
            <Buttonaction
              type="button"
              borderblueOcean
              label="Batal"
              onClick={() => setShow(false)}
              large
            />
          </Col>

          <Col className="d-flex justify-content-start" lg={6}>
            <Buttonaction
              loading={loading}
              type="button"
              label="Minta Uji Gratis"
              blueOcean
              large
              onClick={submitFreeTrial}
            />
          </Col>
        </Row>
      </Modal>
      <SuccessModal passedInRef={modalFreeTrial} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    dataMasters: state.masterDataReducer.dataMasters,
  };
};

export default connect(mapStateToProps)(LandingPage);

const HoverUnderline = styled.div`
  &:hover {
    text-decoration: underline;
  }
`;

const HoverAppBar = styled(Button)`
  position: relative;
  &:hover {
    color: #03d4b4;
    &::after {
      content: "";
      position: absolute;
      display: block;
      height: 5px;
      border-radius: 50px;
      background-color: #03d4b4;
      width: 100%;
      bottom: -22px;
      left: 0;
      z-index: 100000;
    }
  }
`;
